export const SPACER = {
    A: 4,
    B: 8,
    C: 12,
    D: 16,
    E: 24,
    F: 32,
    G: 40,
    H: 48,
    I: 56,
    J: 64,
    K: 80,
    L: 96,
    M: 128,
    N: 160,
    NONE: 0,
};
export const getCFSpacerValue = (spacer) => {
    if (typeof spacer === 'object') {
        return 0;
    }
    if (typeof spacer === 'number') {
        return spacer;
    }
    if (Object.keys(SPACER).includes(spacer.toUpperCase())) {
        return SPACER[spacer.toUpperCase()];
    }
    return 0;
};
export const isCFSpacerSimpleSchema = (spacer) => {
    if (spacer.horizontal ||
        spacer.vertical) {
        return true;
    }
    return false;
};
export const isCFSpacerSchema = (spacer) => {
    if (spacer.bottom ||
        spacer.left ||
        spacer.right ||
        spacer.top) {
        return true;
    }
    return false;
};
